import { AlertTriangle, CheckCircle2, FileText, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import useRiskScan from '../../hooks/useRiskScan';

export default function InventoryTile() {
  const { t } = useTranslation();

  const { hasInventoryScan, isScanOutdated, isInventoryScanLoading } =
    useRiskScan();

  if (isInventoryScanLoading) {
    return (
      <div className="flex flex-col gap-1 rounded-lg bg-neutral-100 p-2 text-sm dark:bg-neutral-900/40">
        <div className="flex items-center gap-1 font-bold text-neutral-800 dark:text-neutral-200">
          {t('ADVISORY_REPORT')}
        </div>

        <div className="">
          <span className="flex items-center gap-1 text-xs text-neutral-800 dark:text-neutral-200">
            <Loader2 className="size-4 animate-spin" />

            {t('LOADING')}
          </span>
        </div>
      </div>
    );
  }

  if (!hasInventoryScan)
    return (
      <div className="flex flex-col gap-1 rounded-lg bg-neutral-100 p-2 text-sm dark:bg-neutral-900/40">
        <div className="flex items-center gap-1 font-bold text-neutral-800 dark:text-neutral-200">
          {t('ADVISORY_REPORT')}
        </div>

        <div className="">
          <span className="flex items-center gap-1 text-xs text-neutral-800 dark:text-neutral-200">
            <FileText className="size-4" />

            {t('STATUS_NOT_STARTED')}
          </span>
        </div>
      </div>
    );

  if (isScanOutdated) {
    return (
      <div className="flex flex-col gap-1 rounded-lg bg-amber-100 p-2 text-sm dark:bg-amber-900/40">
        <div className="flex items-center gap-1 font-bold text-amber-800 dark:text-amber-200">
          {t('ADVISORY_REPORT')}
        </div>

        <div className="">
          <span className="flex items-center gap-1 text-xs text-amber-800 dark:text-amber-200">
            <AlertTriangle className="size-4" />

            {t('STATUS_OLDER_THAN_12M')}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1 rounded-lg bg-green-100 p-2 text-sm dark:bg-green-900/40">
      <div className="flex items-center gap-1 font-bold text-green-800 dark:text-green-200">
        {t('RISKSCAN_INVENTORY')}
      </div>

      <div className="">
        <span className="flex items-center gap-1 text-xs text-green-800 dark:text-green-200">
          <CheckCircle2 className="size-4" />
          {t('STATUS_COMPLETED')}
        </span>
      </div>
    </div>
  );
}
